import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import './Home.css';

const Home = () => {
    const { t, language } = useLanguage();

    const messages = {
        tr: 'Merhaba! Korsan Taksi hakkında bilgi almak istiyorum.',
        en: 'Hello! I would like to get information about the Pirate Taxi.',
        ru: 'Здравствуйте! Я хотел бы получить информацию о Pirate Taxi.',
        ar: 'مرحباً! أود الحصول على معلومات حول سيارة الأجرة الخاصة.',
    };

    const defaultMessage = messages[language] || messages['en'];
    const whatsappLink = `https://wa.me/905379760651?text=${encodeURIComponent(defaultMessage)}`;

    const features = [
        {
            icon: '💰',
            title: t('affordablePrices'),
            description: t('affordablePricesDesc')
        },
        {
            icon: '🚕',
            title: t('qualityVehicles'),
            description: t('qualityVehiclesDesc')
        },
        {
            icon: '📱',
            title: t('easyBooking'),
            description: t('easyBookingDesc')
        },
        {
            icon: '⏰',
            title: t('support247'),
            description: t('support247Desc')
        }
    ];

    return (
        <div className="home">
            {/* Hero Section */}
            <section className="hero">
                <div className="hero-overlay"></div>
                <div className="container">
                    <div className="hero-content">
                        <h1 className="hero-title animate-fade-in">
                            {t('welcomeTitle')}
                        </h1>
                        <p className="hero-subtitle animate-fade-in-delay" style={{ marginBottom: '0.5rem' }}>
                            {t('welcomeSubtitle')}
                        </p>
                        <p className="hero-subtitle animate-fade-in-delay" style={{ marginTop: '0', fontSize: '1.2rem' }}>
                            {t('welcomeNote')}
                        </p>
                        <div className="hero-buttons animate-fade-in-delay-2">
                            <a
                                href={whatsappLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-whatsapp btn-large"
                            >
                                <span style={{ marginRight: '8px' }}>WhatsApp</span>
                            </a>
                            <a
                                href="tel:+905379760651"
                                className="btn btn-call btn-large"
                            >
                                <span style={{ marginRight: '8px' }}>📞</span>
                                {t('callUs')}
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            {/* Features Section */}
            <section className="features">
                <div className="container">
                    <h2 className="section-title">{t('whyChooseUs')}</h2>
                    <div className="features-grid">
                        {features.map((feature, index) => (
                            <div
                                key={index}
                                className="feature-card"
                                style={{ animationDelay: `${index * 0.1}s` }}
                            >
                                <div className="feature-icon">{feature.icon}</div>
                                <h3 className="feature-title">{feature.title}</h3>
                                <p className="feature-description">{feature.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="cta">
                <div className="container">
                    <div className="cta-content">
                        <h2 className="cta-title">{t('reservationForm')}</h2>
                        <p className="cta-text">
                            {t('easyBooking')} - {t('easyBookingDesc')}
                        </p>
                        <Link to="/reservation" className="btn btn-secondary btn-large">
                            {t('bookNow')}
                        </Link>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Home;
